function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgReply = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.485,
    height: 8.933,
    viewBox: "0 0 11.485 8.933",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.528 18.933v-2.776a2.07 2.07 0 0 0-2.074-2.074H7.819l2.457 2.457-.67.67L6 13.605 9.605 10l.67.67-2.456 2.457h6.636a3.036 3.036 0 0 1 3.031 3.031v2.776z",
    transform: "translate(-6 -10)",
    style: {
      fill: "#3953fb"
    }
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReply, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reply.6bf3e872.svg";
export { ForwardRef as ReactComponent };